export const IncomeConfirmationModalTexts = {
  title: 'Как отправим заявку?',
  subtitle: 'Обычно у пользователей с Госуслугами вероятность одобрения выше',
  regularCardTitle: 'Обычная заявка',
  esiaCardTitle: 'Онлайн через Госуслуги',
  sendRegularApplication: 'Отправить обычную заявку',
  esiaButtonPrefix: 'Узнать условия в',
  esiaButtonWithoutCount: 'Узнать условия в банках',
  regularOnlyBankBenefit: 'Отправим заявку только в',
  regularBenefitTermsMayChange: 'Без подтверждения условия по кредиту могут измениться',
  regularBenefitManagerWillCall: 'Менеджер позвонит, чтобы уточнить данные и условия кредита',
  regularBenefitOfficeVisit: 'Нужно приехать в офис, чтобы получить кредит',
  esiaBenefitFinalTerms: 'Покажем финальные условия, никаких «от» и «до»',
  esiaBenefitNoCalls: 'Без звонков от банков — выбирайте и оформляйте онлайн',
  esiaBenefitTermsFor30Days: 'Не спешите — зафиксируем условия на 30 дней',
};
